import { DetailsDisplayMode, PaginationMode, SearchViewDisplayMode } from "@/user-preferences/enums";
import { extractColumnDisplayPreferences } from "@/lib/extract-columns-preferences";
import { event_column_display_seeds } from "./column-display-seeds";
import { GridColumnsPreset } from "@/user-preferences/enums";
import { SearchViewPreferences } from "@/user-preferences/types";
import { EVENTS_VIEW_CUSTOM_DEFAULTS } from "./events-view-custom-defaults";


export const eventsDefaultUserPreferences: SearchViewPreferences['pagePreferences']['events'] = {
    availableDisplayModes: [SearchViewDisplayMode.CALENDAR_WEEK, SearchViewDisplayMode.CALENDAR_DAY, SearchViewDisplayMode.LIST, SearchViewDisplayMode.GRID, SearchViewDisplayMode.TABLE],
    detailsDisplayMode: DetailsDisplayMode.PANEL,
    calendar: {
        firstDayOfWeek: 1, // 0 = Sunday, 1 = Monday
        startHour: 8, // Début de la journée en affichage semaine.
        endHour: 18, // Fin de lajournée en affichage semaine.
        step: 15, // Step in minutes, la précision des heures.
        dayWidth: 90, // Entre 0 et 100, en %. Détermine la place que prennent les tâches dans une colonne de jour. Uniquement en affichage semaine.
        minimumDuration: 15, // La taille par défaut des tâches. Toutes tâche ayant une durée inférieur sera affichée comme ayant cette durée.
        flex: true, // Si les tâches qui en ont la place s'agrandissent.
        highlightDraggedEvent: true, // When a event is dragged, it will be displayed on top of others, and take the total width of a day
        highlightPadding: 1, // padding in px for the currently drag event
        ghost: true, // Show the previous state of the currently dragged event
        focusLayer: true, // Display focus layer ? Focus layer is display behind the currently edited event, and above other events. Its style can be edited, and it change some clicks behaviors.
        deadlineDurationReplacer: 60, // La durée que doit prendre en compte le calendrier pour afficher une tâches qui n'a techniquement pas de durée
        displayWeekend: false, // Show Saturday and Sunday in week view
        showWeekdayNames: true, // Show weekday name above each day in the header (e.g. Mon.)
        dayNumber: true, // Display day number
        enableEditor: true, // Display editor
        focusHours: true, // highlight la duree d'une tache sur toute la largeur du calendrier lorsau'elle est drag
        emptyGridHoverTimeLine: true,
        dynamicDayWidth: false, // No hover expansion of day columns by default
        dynamicDayWidthTransition: false, // No transition on width change by default
    },
    table: {
        fontSize: 14,
        defaultItemsPerPage: 20,
        displayItemsPerPageSelector: true,
        paginationMode: PaginationMode.PAGED,
        verticalPadding: 14,
        zebraLines: true,
        showVerticalLines: true,
        showHorizontalLines: false,
        wrapText: false,
        columns: extractColumnDisplayPreferences(event_column_display_seeds),
    },
    grid: {
        masonryStyle: false,
        availableGridColumns: [
            GridColumnsPreset.AUTO_200,
            GridColumnsPreset.AUTO_250,
            GridColumnsPreset.AUTO_300,
            GridColumnsPreset.AUTO_400,
        ],
        gridColumns: GridColumnsPreset.AUTO_250,
    },
    viewCustom: {
        ...EVENTS_VIEW_CUSTOM_DEFAULTS,
    }
}
